import { render, staticRenderFns } from "./AlertLegend.vue?vue&type=template&id=5e612c3a&scoped=true&"
import script from "./AlertLegend.vue?vue&type=script&lang=js&"
export * from "./AlertLegend.vue?vue&type=script&lang=js&"
import style0 from "./AlertLegend.vue?vue&type=style&index=0&id=5e612c3a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e612c3a",
  null
  
)

/* custom blocks */
import block0 from "./AlertLegend.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e612c3a')) {
      api.createRecord('5e612c3a', component.options)
    } else {
      api.reload('5e612c3a', component.options)
    }
    module.hot.accept("./AlertLegend.vue?vue&type=template&id=5e612c3a&scoped=true&", function () {
      api.rerender('5e612c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/AlertLegend.vue"
export default component.exports